import { FC, useRef } from 'react'
import { FeatureGroup, LayersControl } from 'react-leaflet'
import { Menu } from '../Menu.tsx'
import { Layers } from '@/js/editor/components/map/Layers.tsx'
import { MapCanvas } from '@/components/shared/MapCanvas.tsx'
import { mapDataAtom } from '@/js/editor/state/mapAtoms.ts'
import { useAtomValue, useSetAtom } from 'jotai'
import { effectiveActivePoiAtom, updatePoiDraftAtom } from '@/js/editor/state/poiAtoms.ts'
import { GeomanControls } from 'react-leaflet-geoman-v2'
// @ts-ignore
import { DirectGeometryObject, Feature } from 'geojson'

export const Map: FC = () => {
    const { uses_tags_as_categories } = useAtomValue(mapDataAtom)
    const activePoi = useAtomValue(effectiveActivePoiAtom)
    const activePoiRef = useRef(activePoi)
    const updateDraft = useSetAtom(updatePoiDraftAtom)

    return (
        <MapCanvas>
            <GeomanControls
                options={{
                    editControls: false,
                    drawControls: false,
                }}
                onCreate={({ layer, shape }) => {
                    const poi = activePoiRef.current

                    if (poi == null || shape === 'Marker') {
                        layer.remove()

                        return
                    }

                    // @ts-ignore
                    const geoJson: Feature<DirectGeometryObject> = layer.toGeoJSON()
                    const geometries = poi.geometries?.geometries ?? []

                    updateDraft({
                        geometries: {
                            type: 'GeometryCollection',
                            geometries: [...geometries, geoJson.geometry],
                        },
                    })

                    layer.remove()
                }}
            />

            <Menu isCategorized={uses_tags_as_categories ?? false} />

            <FeatureGroup>
                <LayersControl position="bottomright">
                    <Layers />
                </LayersControl>
            </FeatureGroup>
        </MapCanvas>
    )
}
